import {
  SEND_LOGO_SUCCESS,
  SEND_LOGO_FAIL,
  GET_LOGO_SUCCESS,
  GET_LOGO_FAIL,
  TOGGLE_ACCOUNT_MENU_DROPDOWN
} from './actions';

const initialState = {
  showAcctMenuDropdown: false,
  logoImg: '',
  error: ''
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_ACCOUNT_MENU_DROPDOWN:
      return {
        ...state,
        showAcctMenuDropdown: action.data
      };
    case GET_LOGO_SUCCESS:
    case SEND_LOGO_SUCCESS:
      return {
        ...state,
        logoImg: action.data
      };
    case GET_LOGO_FAIL:
    case SEND_LOGO_FAIL:
      return {
        ...state,
        error: action.err
      };
    default:
      return state;
  }
};

export default reducer;
